<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newOrder">
            <i class="el-icon-plus"></i>
            添加
          </el-button>
          <!-- <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            :header-cell-style="getRowClass"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input> -->
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="name"
            label="模版名称">
          </el-table-column>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="创建人">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="到期日期">
          </el-table-column>
          <el-table-column label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row, scope.$index)">
                <i class="el-icon-edit-outline"></i>
                修改
              </el-button>
              <el-button
                class="delete-btn"
                @click="handleDelete(scope.row, scope.$index)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加模版 -->
    <el-dialog
      :title="ruleAdd.title"
      class="dialog-container"
      :visible.sync="dialogUpdate">
      <el-form class="form-container" >
          <el-form-item class="input-list" label="仪器名称">
            <!-- <el-input type="text" placeholder="请输入仪器名称" v-model="ruleAdd.name"></el-input> -->
            <el-autocomplete
              placeholder="请输入仪器名称"
              v-model="ruleAdd.device_name"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus = "false"
              :select-when-unmatched = "true"
              @select="handleSelect"
              value-key="device_name"
              >
            </el-autocomplete>
          </el-form-item>
          <el-form-item class="input-list" label="模版名称" >
            <el-input type="text" placeholder="请输入模版名称" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="模版上传" >
            <el-upload
              class="upload-demo"
              :http-request="sendExcel"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept=".xls,.XLS,.xlsx,.XLSX"
              :action="uploadUrl"
              >
              <el-button class="upload-btn">文件上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item class="input-list" label="提示">
            <span class="red-txt">您只能选择与您能力匹配的仪器模版</span>
          </el-form-item>

        </el-form>
    </el-dialog>
    <!-- 修改模版 -->
    <el-dialog
      :title="ruleAdd.title"
      class="dialog-container"
      :visible.sync="updateTemp">
      <el-form class="form-container" >
          <el-form-item class="input-list" label="仪器名称">
            <!-- <el-input type="text" placeholder="请输入仪器名称" v-model="ruleAdd.name"></el-input> -->
            <el-autocomplete
              placeholder="请输入仪器名称"
              v-model="ruleAdd.device_name"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus = "false"
              :select-when-unmatched = "true"
              @select="handleSelect"
              value-key="device_name"
              >
            </el-autocomplete>
          </el-form-item>
          <el-form-item class="input-list" label="模版名称" >
            <el-input type="text" placeholder="请输入模版名称" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="提示">
            <span class="red-txt">您只能选择与您能力匹配的仪器</span>
          </el-form-item>
          <el-form-item class="btn-list">
            <el-button class="login-btn" @click="submitForm">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 删除的弹框 -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
  </div>
</template>

<script type="text/javascript">
import DeleteBox from 'components/DeleteBox.vue'
export default {
  data() {
    return {
      empty: '没有模版列表',
      page: 1,
      limit: 10,
      tableData: [],
      total: 0,
      dialogUpdate: false,
      search_name: '',
      ruleAdd: {},
      uploadUrl: '',
      device_list: [],
      updateTemp: false,
      tempIndex: null,
      deleteRow: {}, // 删除的数据
      deleteShow: false, // 删除弹框的显示
      deleteIndex: null
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData() {
      let that = this
      that.$api.getTemplate({
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.data.length > 0) {
          that.tableData = res.data.data
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.data
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    newOrder() {
      this.ruleAdd = {}
      this.ruleAdd.title = "添加模版"
      this.dialogUpdate = true
    },
    querySearchAsync (queryString, cb) {
      let that = this
      that.$api.searchTemplate({
        device_name: queryString
      }).then(res => {
        that.device_list = res.data
        cb(res.data)
      })
    },
    handleSelect(item) {
      let that = this
      that.ruleAdd.device_name = item.device_name
      that.ruleAdd.device_name_id = item.device_name_id
    },
    beforeUpload(file) { // 上传文件之前
      let isLt8M = file.size / 1024 / 1024 < 8
      if (!isLt8M) {
        this.$message({
          type: 'error',
          message: '上传的文件不能超过8M',
          customClass: 'msg-position',
          showClose: true
        })
      }
      let can = (this.ruleAdd.hasOwnProperty('device_name_id') && this.ruleAdd.device_name_id)
      if (!can) {
        this.$message({
          type: 'error',
          message: '仪器名称选择不合格',
          customClass: 'msg-position',
          showClose: true
        })
      }
      let nameCan = (this.ruleAdd.hasOwnProperty('name') && this.ruleAdd.name)
      if (!nameCan) {
        this.$message({
          type: 'error',
          message: '模版名称不能为空！',
          customClass: 'msg-position',
          showClose: true
        })
      }
      return isLt8M && can && nameCan
    },
    sendExcel(param) { // 上传文件
      let formData = new FormData()
      let that = this
      formData.append('userfile', param.file)
      formData.append('name', that.ruleAdd.name)
      formData.append('device_name_id', that.ruleAdd.device_name_id)
      that.$api.sendExcel(formData).then(res => {
        that.dialogUpdate = false
        if (res.data.msg == true) {
          that.$message({
            type: 'success',
            message: '模版上传成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.initData()
        } else {
          that.$message({
            type: 'error',
            message:`${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    // 修改 规格
    handleEdit (row, index) {
      let that = this
      that.ruleAdd = {
        title: "修改模版",
        ...row
      }
      that.tempIndex = index
      that.updateTemp = true
    },
    submitForm() { // 修改保存
      let that = this
      let can = (that.ruleAdd.hasOwnProperty('device_name_id') && that.ruleAdd.device_name_id)
      if (!can) {
        that.$message({
          type: 'error',
          message:'仪器名称选择不合格',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      let nameCan = (that.ruleAdd.hasOwnProperty('name') && that.ruleAdd.name)
      if (!nameCan) {
        that.$message({
          type: 'error',
          message: '模版名称不能为空！',
          customClass: 'msg-position',
          showClose: true
        })
        return
      }
      that.$api.updateTemplate({
        temp_id: that.ruleAdd.template_id,
        cert_device_id: that.ruleAdd.cert_device_id,
        name: that.ruleAdd.name,
        device_name_id : that.ruleAdd.device_name_id
      }).then(res => {
        if (res.data.msg === true) {
          that.$message({
            type: 'success',
            message: '模版修改成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.tableData[that.tempIndex] = {...that.ruleAdd}
          that.updateTemp = false
        } else {
          that.$message({
            type: 'error',
            message: `${res.data.error}`,
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    handleDelete (row, index) { // 删除 已经能够做的 仪器
      let that = this
      that.deleteRow = {...row}
      that.deleteIndex = index
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.deleteShow = false
        that.delete(that.deleteRow.template_id, that.deleteRow.cert_device_id)
        that.rightLoading = false
        that.deleteRow = {}
      }
    },
    delete (temp_id, cert_device_id) {
      let that = this
      this.$api. deleteTemplate({
        temp_id: temp_id,
        cert_device_id: cert_device_id
      }).then(res => {
        if (res.data.msg === true) {
          /* let index = that.tableData.findIndex(item => {
            return item.cert_device_id == cert_device_id &&  item.temp_id == temp_id
          }) */
          that.tableData.splice(that.deleteIndex, 1)
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    searchName () {
      // 模版搜索
    }
  },
  components: {
    DeleteBox
  }
}
</script>

<style lang="stylus" >
@import '~common/stylus/box.styl'
  .dialog-container
    display:flex;
    justify-content: center;
    align-items: center;
    .el-dialog
      width:25rem;
      margin:0px !important;
    .el-dialog__header
      height:3rem;
      padding:0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1D489E;
      .el-dialog__title
        color: #fff;
      .el-dialog__headerbtn
        .el-icon
          color:#fff;
          font-size: 1.2rem;
    .form-container
      border: 0;
      padding: 2rem;
      .input-list
        display: flex;
        margin-bottom: 1rem;
        &.is-error
          .el-form-item__content
            .el-input
              .el-input__inner
                border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 5rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          height:2rem;
          flex: 1;
          .el-autocomplete
            width: 100%;
          .red-txt
            font-size:0.7rem;
            color:red;
          .el-input
            height:2rem;
            width:100%;
            .el-input__inner
              width:100%;
              border: 0.05rem solid #cfcfcf;
            &.date-input
              width:100%;
              .el-input__inner
                /* padding: 0 1rem; */
              .el-input__prefix
                display:none;
          .options-select
            width:100%;
          .el-form-item__error
            /* top:0.5rem; */
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
        .upload-demo
          .upload-btn
            width: 4rem;
            height: 1.6rem;
            padding: 0;
            background: #1d489e;
            border-radius: 0.1rem;
            border: none;
            color:#fff;
            span
              color:#fff;
</style>
